import { Link } from "react-router-dom";
import { Flame, Instagram, Facebook, Youtube, Phone, BadgeCheck } from "lucide-react";
import Marquee from "react-fast-marquee";
import { SAFETY_PRINCIPLES, SOCIAL, CONTACT } from "@/data/brand";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-sq-ink text-white">
      <div className="border-y border-white/10 py-5">
        <Marquee speed={40} gradient={false} autoFill>
          {SAFETY_PRINCIPLES.map((p, i) => (
            <span key={i} className="mx-6 font-display text-3xl tracking-wide text-white/70">
              {p} <span className="text-sq-yellow mx-3">✦</span>
            </span>
          ))}
        </Marquee>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-sq-red text-white"><Flame size={20} /></span>
            <span className="font-display text-2xl tracking-wide pt-1">THE SAFETY QUEST</span>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            Empowering children with life-saving safety skills through books, music and animated
            adventures with Bobby & Pluggy. A family-run mission, from Georgia to the world.
          </p>
          <div data-testid="footer-partner-badge" className="inline-flex items-center gap-2 mt-6 px-4 py-2 rounded-full border border-white/15 bg-white/5 text-sm font-semibold">
            <BadgeCheck size={18} className="text-sq-yellow" /> Authorized Robotronics Sponsor-Partner
          </div>
          <div className="flex gap-3 mt-6">
            {[
              { Icon: Instagram, href: SOCIAL.instagram, label: "instagram" },
              { Icon: Facebook, href: SOCIAL.facebook, label: "facebook" },
              { Icon: Youtube, href: SOCIAL.youtube, label: "youtube" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`social-${label}`}
                className="grid place-items-center w-10 h-10 rounded-full bg-white/10 hover:bg-sq-yellow hover:text-sq-ink transition-colors"
              >
                <Icon size={18} />
              </a>
            ))}
            <a
              href={CONTACT.phoneHref}
              aria-label="phone"
              data-testid="social-phone"
              className="grid place-items-center w-10 h-10 rounded-full bg-white/10 hover:bg-sq-yellow hover:text-sq-ink transition-colors"
            >
              <Phone size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-round font-semibold text-sq-yellow mb-4">Explore</h4>
          <ul className="space-y-2 text-white/70">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/books" className="hover:text-white">Books & Media</Link></li>
            <li><Link to="/blog" className="hover:text-white">Safety Resources</Link></li>
            <li><Link to="/programs" className="hover:text-white">Programs</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-round font-semibold text-sq-yellow mb-4">For Partners</h4>
          <ul className="space-y-2 text-white/70">
            <li><Link to="/programs" className="hover:text-white">Sponsorships</Link></li>
            <li><Link to="/robotics" className="hover:text-white">Shop Pluggy Robots</Link></li>
            <li><Link to="/programs" className="hover:text-white">Schools & Daycares</Link></li>
            <li><Link to="/programs" className="hover:text-white">Custom Songs & Animations</Link></li>
            <li><Link to="/contact" className="hover:text-white">Media Inquiries</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 text-center text-white/40 text-sm">
        © {new Date().getFullYear()} The Safety Quest. Created by Bobby & Nekia Martin. All rights reserved.
      </div>
    </footer>
  );
}
